import { demoFile, component, story, CLICK, variant, componentWithVariants } from "system/demo";
import { ArticleAdminScreen, ArticleFeaturesScreen, ArticleOverlayScreen, ArticleScreen, ArticleTeaser } from 'structure/article';
import { EditorialQuestionTeaser } from "feature/teaser/editorial-question";
import { View } from "react-native";
import { UtilityText } from "component/text";
import { t } from "util/stdtypes";

demoFile('structure/article');

// Article Teaser
componentWithVariants('ArticleTeaser', ArticleTeaser, {
    structureKey: 'article',
    config: {
        teaser: EditorialQuestionTeaser
    }
}, [
    variant(null, {
        structureKey: 'article',
        config: {
            teaser: EditorialQuestionTeaser
        }
    }),
    variant('No Teaser Admin', {
        state: {
            roles: ['Editorial']
        }
    }, [
        story('Edit Questions', [
            CLICK('Edit questions (admin)')
        ])
    ])
]);

// Article Admin Screen
componentWithVariants('ArticleAdminScreen', ArticleAdminScreen, {
    state: {
        roles: ['Editorial']
    }
}, [
    variant(null, {
        state: {
            roles: ['Editorial']
        }
    }),
    variant('No teaser', {
        state: {
            roles: ['Editorial']
        }
    }),
    variant('Not admin')
]);

// Article Features Screen
component('ArticleFeaturesScreen', ArticleFeaturesScreen, {
    structureKey: 'article',
    state: {
        roles: ['Owner']
    }
});

// Article Screen
componentWithVariants('ArticleScreen', ArticleScreen, {
    state: {
        roles: ['Owner']
    },
    structureKey: 'article',
    config: {adminButtonLabel: t('Edit questions (admin)')}
}, [
    variant('Not admin'),
    variant('Not logged in', {
        state: {
            personaKey: null
        }
    })
]);

// Article Overlay Screen
component('ArticleOverlayScreen', ArticleOverlayScreen, {
    structureKey: 'article',
    config: {overlayScreen: () => <View><UtilityText text='Overlay Screen' /></View>}
}); 